<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8">
      <div class="bolder spacing">
        Orthopaedic In-Training Exam Registration
      </div>
      <div class="spacing spacing--sm" *ngIf="!loading">
        <span *ngIf="oiteProduct.seatAssignmentPeriodActive">
          Resident registration for the Orthopaedic In-Training Exam (OITE) must be completed by {{oiteProduct.seatAssignmentEndDate | date: 'MMMM d, y'}}. Please
          check the box next to each resident in the roster who will be taking the exam and select Save. To select all residents at one time, 
          check the box in upper left corner of the table.
        </span>
        <span *ngIf="!oiteProduct.seatAssignmentPeriodActive">
          Resident registration for the Orthopaedic In-Training Exam (OITE) is not currently active. The registration period is {{oiteProduct.seatAssignmentBeginDate | date: 'MMMM d'}} 
          through {{oiteProduct.seatAssignmentEndDate | date: 'MMMM d'}}.<br>
          <br>
          During the registration period, select residents who will be taking the exam from the roster below and submit them with a single click to complete the registration process.
        </span>
      </div>
      <div class="spacing">
        OITE invoices will be issued in May alongside other resident education products to align with the academic-year billing cycle. Contact AAOS customer service at 800-626-6726 with any questions about subscription status and invoicing.
      </div>
      <div *ngIf="!loading">
        <aaos-oite-paid-seats-table [oiteProduct]="oiteProduct" [productId]="productId"></aaos-oite-paid-seats-table>
      </div>
    </div>
  </div>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
